<template>
    <span class="vuetify-wrapper">
        <v-menu
            v-model="menuOpen"
            :close-on-content-click="false"
            nudge-width="360"
            offset-x
            content-class="v-application"
        >
            <template v-slot:activator="{ on: menu, attrs }">
                <v-tooltip left max-width="360">
                    <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                            v-bind="attrs"
                            v-on="{ ...tooltip, ...menu }"
                            :loading="loading"
                            class="approval-automation-block-btn"
                            min-width="30"
                            small
                            :title="title"
                        >
                            <v-icon small :color="isBlocked ? 'red' : 'green'">
                                {{ isBlocked ? 'mdi-lock' : 'mdi-lock-open-variant' }}
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>{{ title }}</span>
                </v-tooltip>
            </template>

            <v-card>
                <v-card-title>{{ isBlocked ? 'Automatik entsperren' : 'Automatik sperren' }}</v-card-title>
                <v-card-text>
                    <p v-if="isBlocked">
                        Automatische Erinnerungen, Freigabe und ApoBilanz-Weitergabe sind pausiert.
                    </p>
                    <v-text-field
                        v-else
                        v-model="reason"
                        label="Sperrgrund (optional)"
                        maxlength="500"
                        counter="500"
                        outlined
                        dense
                    />
                    <p v-if="isBlocked && currentReason" class="mb-0">
                        Grund: {{ currentReason }}
                    </p>
                </v-card-text>
                <v-divider />
                <v-card-actions class="justify-end">
                    <v-btn text small @click="menuOpen = false">Abbrechen</v-btn>
                    <v-btn
                        :color="isBlocked ? 'green' : 'red'"
                        class="approval-automation-block-save-btn"
                        outlined
                        small
                        @click="save"
                    >
                        {{ isBlocked ? 'Entsperren' : 'Sperren' }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-menu>
    </span>
</template>

<script>
import axios from 'axios';
import { mapMutations } from 'vuex';

export default {
    name: 'ToggleApprovalAutomationBlockBtn',
    props: {
        appointmentid: String,
        block: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            loading: false,
            menuOpen: false,
            reason: '',
        };
    },
    computed: {
        isBlocked() {
            return this.block?.active === true;
        },
        currentReason() {
            return this.block?.reason || '';
        },
        title() {
            return this.isBlocked
                ? 'Automatik gesperrt – keine automatische Erinnerung, Freigabe oder ApoBilanz-Weitergabe.'
                : 'Automatik aktiv – klicken, um Erinnerungen, Freigabe und ApoBilanz-Weitergabe zu sperren.';
        },
    },
    methods: {
        async save() {
            this.loading = true;
            try {
                const response = await axios.post(
                    `/api/appointments/${this.appointmentid}/approval_automation_block`,
                    {
                        active: !this.isBlocked,
                        reason: this.isBlocked ? null : this.reason,
                    },
                );
                const updatedAppointments = response.data.appointments || [];
                const updatedAppointment = updatedAppointments.find(
                    appointment => appointment._id === this.appointmentid,
                );
                if (!updatedAppointment) {
                    throw new Error('Aktualisierter Termin wurde nicht gefunden.');
                }
                this.menuOpen = false;
                this.reason = '';
                updatedAppointments.forEach(appointment => {
                    this.$emit('update', {
                        _id: appointment._id,
                        approval_automation_block: appointment.approval_automation_block,
                    });
                });
            } catch (error) {
                const message = error?.response?.data?.error || error;
                this.alertError(message);
            } finally {
                this.loading = false;
            }
        },
        ...mapMutations({
            alertError: 'alert/error',
        }),
    },
};
</script>
